<article class="bg-white rounded-2xl border border-dark-text/8 p-6">
  <div class="flex items-center gap-3 mb-3">
    <div class="w-10 h-10 rounded-full bg-jungle-green/15 flex items-center justify-center">
      <span class="font-body font-bold text-sm text-jungle-green">{{ review.authorInitials }}</span>
    </div>
    <div>
      <div class="font-body font-bold text-sm text-dark-text">{{ review.authorName }}</div>
      <div class="text-xs text-muted-text font-body">{{ review.date }}</div>
    </div>
  </div>
  <div class="flex items-center gap-1 mb-2">
    @for (i of stars; track i) {
      @switch (starState(i, review.rating)) {
        @case ('full') {
          <span aria-hidden="true" class="material-symbols-outlined text-sm text-trinidad" style="font-variation-settings: 'FILL' 1;">star</span>
        }
        @case ('half') {
          <span aria-hidden="true" class="material-symbols-outlined text-sm text-trinidad" style="font-variation-settings: 'FILL' 1;">star_half</span>
        }
        @default {
          <span aria-hidden="true" class="material-symbols-outlined text-sm text-dark-text opacity-20" style="font-variation-settings: 'FILL' 1;">star</span>
        }
      }
    }
    <span class="ml-1 text-xs font-body font-bold text-dark-text">{{ review.rating.toFixed(1) }}</span>
  </div>
  <p class="text-base font-body text-dark-text leading-relaxed">{{ review.text }}</p>

  @if (hasPhotos) {
    <div class="mt-3 -mx-1 overflow-x-auto">
      <div class="flex gap-2 px-1 pb-1">
        @for (photo of review.photos; track photo + $index) {
          <a [href]="photo" target="_blank" rel="noopener"
            class="block w-20 h-20 shrink-0 rounded-md overflow-hidden bg-cream/60 border border-dark-text/10 hover:border-trinidad transition-colors">
            <img [src]="photo" alt="Review photo" class="w-full h-full object-cover" />
          </a>
        }
      </div>
    </div>
  }

  <!-- TODO: Re-enable the Helpful button once votes persist to the backend.
       ReviewService.toggleHelpful/helpfulCount are client-side only, so votes
       aren't saved or shared. Parent bindings (helpfulCount, hasVoted,
       helpfulToggle) are left in place for when this returns.
  @if (canVote) {
    <div class="mt-3 flex items-center gap-2">
      <button type="button" (click)="helpfulToggle.emit()"
        [class.bg-jungle-green]="hasVoted"
        [class.text-white]="hasVoted"
        [class.bg-white]="!hasVoted"
        [class.text-dark-text]="!hasVoted"
        class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border border-dark-text/15 text-[0.65rem] uppercase tracking-[0.12em] font-button font-bold hover:border-jungle-green transition-colors">
        @if (hasVoted) {
          <span aria-hidden="true" class="material-symbols-outlined text-sm" style="font-variation-settings: 'FILL' 1;">thumb_up</span>
        } @else {
          <span aria-hidden="true" class="material-symbols-outlined text-sm">thumb_up</span>
        }
        Helpful
        @if (helpfulCount > 0) {
          <span class="font-body font-bold normal-case tracking-normal">· {{ helpfulCount }}</span>
        }
      </button>
    </div>
  }
  -->


  @if (review.hostResponse; as resp) {
    <div class="mt-4 ml-4 pl-4 border-l-2 border-jungle-green/40 bg-jungle-green/5 rounded-r-md py-3 pr-3">
      <div class="flex items-center gap-1.5 text-[0.65rem] font-label uppercase tracking-[0.12em] font-bold text-jungle-green mb-1">
        <span aria-hidden="true" class="material-symbols-outlined text-sm" style="font-variation-settings: 'FILL' 1;">reply</span>
        Response from the host
        <span class="text-muted-text font-normal normal-case tracking-normal">· {{ resp.respondedAt | date:'mediumDate' }}</span>
      </div>
      <p class="text-sm font-body text-dark-text leading-relaxed whitespace-pre-line">{{ resp.text }}</p>
    </div>
  }
</article>
